import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

const NotFound = () => (
  <div className="max-w-md mx-auto px-6 py-24 text-center" data-testid="not-found-page">
    <AlertTriangle className="h-12 w-12 text-[#FFE800] mx-auto mb-4" />
    <h1 className="font-headings text-3xl uppercase tracking-widest text-[#FFE800] mb-2">
      404
    </h1>
    <p className="text-sm text-gray-400 mb-6">
      Stratagem not found. This sector has been evacuated.
    </p>
    <Link
      to="/"
      className="inline-block bg-[#FFE800] text-black font-headings uppercase tracking-widest py-3 px-8 hover:bg-[#FFD700]"
      data-testid="not-found-home-link"
    >
      Return to Briefing
    </Link>
  </div>
);

export default NotFound;
